module.exports = __webpack_public_path__ + "img/04.489d3f54.png";